// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 689 ? "LazyPage1" : chunkId) + "." + {"689":"fd999001","704":"9187491c","787":"3b947989"}[chunkId] + ".chunk.js";
};